import gql from 'graphql-tag';
export default gql`
  mutation saveFile($file: Upload) {
    saveFile(file: $file) {
      uuid
      signedUrl
      fileName
      mimeType
    }
  }
`;
